import { cashlessRemittanceList, cashLessUnRemittedViews, cashlessRemittanceStatus, apiEditRemittance, apiBanks, apiFetchOptionsLike } from '../../services/apiEndpoints';
const page = 'cashless-remittance'

const SET_CASHLESS_REMITTANCE_STATUS = 'cashierRemmittance/SET_CASHLESS_REMITTANCE_STATUS';
export const setCashlessRemittanceStatus = (dm,bank_ref, status, data) => ({
  type: SET_CASHLESS_REMITTANCE_STATUS,
  payload: {
    client: 'secure',
    request: {
      ...cashlessRemittanceStatus(page, dm, bank_ref ,status),
      data
    },
  },
});

const FETCH_OPTIONS = 'reports/FETCH_OPTIONS';
export const fetchOptions = (option, value) => ({
  type: FETCH_OPTIONS,
  payload: {
    client: 'secure',
    request: {
      ...apiFetchOptionsLike(option, value),
    },
  },
});

const GET_BANKS = 'cashierRemmittance/GET_BANKS';
export const getBanks = () => ({
  type: GET_BANKS,
  payload: {
    client: 'secure',
    request: {
      ...apiBanks,
    },
  },
});

const EDIT_REMITTANCE = 'cashierRemmittance/EDIT_REMITTANCE';
export const editRemittance = data => ({
  type: EDIT_REMITTANCE,
  payload: {
    client: 'secure',
    request: {
      ...apiEditRemittance,
      data,
    },
  },
});

const CASHLESS_REMITTANCE_REMITTED_VIEWS = 'cashlessRemittance/CASHLESS_REMITTANCE_REMITTED_VIEWS';
const CASHLESS_REMITTANCE_REMITTED_VIEWS_SUCCESS = 'cashlessRemittance/CASHLESS_REMITTANCE_REMITTED_VIEWS_SUCCESS';
export const cashlessUnRemittedViewsAccount = (id) => ({
  type: CASHLESS_REMITTANCE_REMITTED_VIEWS,
  payload: {
    client: 'secure',
    request: {
      ...cashLessUnRemittedViews(page, id),
    },
  },
});

const CASHLESS_REMITTANCE_LIST = 'cashlessRemittance/CASHLESS_REMITTANCE_LIST';
const CASHLESS_REMITTANCE_LIST_SUCCESS = 'cashlessRemittance/CASHLESS_REMITTANCE_LIST_SUCCESS';

export const cashlessRemittedList = filter => ({
  type: CASHLESS_REMITTANCE_LIST,
  payload: {
    client: 'secure',
    request: {
      ...cashlessRemittanceList(page),
      data: {
        export: false,
        filter,
        page: 0,
        pageSize: 100000000000,
        sorted: [],
      },
    },
  },
});

const CASHLESS_REMITTANCE_NONFILTER_LIST = 'cashlessRemittance/CASHLESS_REMITTANCE_NONFILTER_LIST';
const CASHLESS_REMITTANCE_NONFILTER_LIST_SUCCESS = 'cashlessRemittance/CASHLESS_REMITTANCE_NONFILTER_LIST_SUCCESS';

export const cashlessRemittednonFilterList = data => ({
  type: CASHLESS_REMITTANCE_NONFILTER_LIST,
  payload: {
    client: 'secure',
    request: {
      ...cashlessRemittanceList(page),
      data,
    },
  },
});

const initialState = {
  listViews: {},
  createRemittanceData: {},
  data: [],
  dataRItems: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case CASHLESS_REMITTANCE_NONFILTER_LIST_SUCCESS:
      return {
        ...state,
        data: action.payload.data.rows,
      };

    case CASHLESS_REMITTANCE_REMITTED_VIEWS_SUCCESS:
      return {
        ...state,
        listViews: action.payload.data,
      };

    case CASHLESS_REMITTANCE_LIST_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload.data],
      };

    default:
      return state;
  }
}

export default reducer;
